/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * てのひら眼科 Patient API
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import {
  useCallback
} from 'react'
import type {
  ForbiddenResponse,
  GetMeResponseDTO,
  InternalServerErrorResponse,
  UnauthorizedResponse
} from '.././model'
import { useAPIPatientClient } from '../../apiPatientConfig';
import type { ErrorType } from '../../apiPatientConfig';



/**
 * ログイン中の患者自身の情報を取得する。
 * @summary ログイン患者情報の取得
 */
export const useGetMeHook = () => {
        const getMe = useAPIPatientClient<GetMeResponseDTO>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getMe(
          {url: `/patient/api/me`, method: 'GET', signal
    },
          );
        }, [getMe])
      }
    

export const getGetMeQueryKey = () => {
    return [`/patient/api/me`] as const;
    }

    
export const useGetMeQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetMeHook>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | InternalServerErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMeHook>>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();

  const getMe =  useGetMeHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetMeHook>>>> = ({ signal }) => getMe(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMeHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetMeHook>>>>
export type GetMeQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | InternalServerErrorResponse>

/**
 * @summary ログイン患者情報の取得
 */
export const useGetMe = <TData = Awaited<ReturnType<ReturnType<typeof useGetMeHook>>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | InternalServerErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMeHook>>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = useGetMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



